import { Box } from '@mui/material';
import ColorButton from './ColorButton';
import { ColorButtonGroupProps } from './colorButton.types';

const ColorButtonGroup = ({
  items,
  selectedId,
  size,
  wrap = false,
  tabIndex,
  testId,
  onSelect,
}: ColorButtonGroupProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Box
      test-id={testId}
      sx={{ display: 'flex', alignItems: 'center', flexWrap: wrap ? 'wrap' : 'nowrap', gap: 0.5 }}
    >
      {items.map((item) => (
        <ColorButton
          key={item.id}
          label={item.label}
          hexcode={item.hexcode}
          imageUrl={item.imageUrl}
          isSelected={item.id === selectedId}
          size={size}
          tabIndex={tabIndex}
          testId={item.testId}
          onClick={(event) => onSelect?.(item.id, event)}
        />
      ))}
    </Box>
  );
};

export default ColorButtonGroup;
